import { List } from "antd";
import { GoPrimitiveDot } from "react-icons/go";
import styles from "./Notification.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import NotificationMiddleware from "../../../store/Middlewares/NotificationMiddleware";
import moment from "moment/moment";
const Notification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = useSelector(state => state.AuthReducer.user);
  const [Notification, setNotification] = useState([]);
  console.log('notififcationsss', Notification);
  useEffect(() => {
    onPressgetUserNotifications();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = await localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const onPressgetUserNotifications = () => {
    dispatch(NotificationMiddleware.getUserNotifications())
      .then(data => {
        setNotification(data?.data);
      })
      .catch(error => {
        console.warn(error);
      });
  };
  
  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
      >
        <div className={styles.box_itemColLeft}>
         <GoPrimitiveDot className={styles.dot}/>
          {/* {user?.role == 'contractor' ? ( */}
            <div className={styles.data}>
              <h1>{item?.title}</h1>
              <p>{item?.message?.length > 130 ? item?.message?.slice(0,130) + '...' : item?.message}</p>
              <p>{item?.location}</p>
            </div>
          {/* ) : ( */}
            {/* <div className={styles.data}>
              <h1>{item?.title}</h1>
              <p>{t('has assigned you the new')} {' '}</p>
              <p>Job</p>
            </div>)} */}
        </div>
        <div className={styles.box_itemColRight}>
          <div className={styles.dataRight}>
            <span>{moment(item?.created_at).fromNow()}</span>
            <p>{moment(item?.created_at).format('dddd, MMM DD')}</p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Notifications")}</h1>
      </div>
      <List
        style={{ width: "100%", margin: '50px 0px' }}
        // grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={Notification ? Notification : [] }
        renderItem={renderItem}
      />
    </div>
  );
};
export default Notification;
